import type { CampaignAttributes } from "hooks/api/use-campaigns";

import { getCampaignPaths, getClientPaths } from "utilities/app-routes";

import { getProgramTypeLabel } from "containers/admin/clients/client/campaign-templates-page/campaign-template.constants";
import type { CampaignTemplateProgram } from "containers/admin/clients/client/campaign-templates-page/campaign-templates-page.types";

export type RewriteStrategyLinks = {
  programStrategyLabel: string;
  programStrategyHref: string;
  campaignStrategyLabel: string;
  campaignStrategyHref: string;
};

export const getRewriteStrategyLinks = (
  clientId: string,
  campaign: Pick<CampaignAttributes, "id" | "name" | "programType">,
): RewriteStrategyLinks => {
  const { clientProgramsA2APath, clientProgramsA2EPath } = getClientPaths({ clientId });
  const { campaignStrategyPath } = getCampaignPaths({ clientId, campaignId: campaign.id });

  return {
    programStrategyLabel: campaign.programType
      ? (getProgramTypeLabel(campaign.programType as CampaignTemplateProgram) as string)
      : "Program strategy",
    programStrategyHref:
      campaign.programType === "ADMIT_TO_ENROLL" ? clientProgramsA2EPath : clientProgramsA2APath,
    campaignStrategyLabel: campaign.name,
    campaignStrategyHref: campaignStrategyPath,
  };
};
